module.exports = __webpack_public_path__ + "static/media/GEM-sunset.8a7f2774.jpg";